import { SET_RAW_DATA } from '../actionConstants';
import { ProductMenuItem } from '../productMenu/productMenuTypes';

/**
 * Set raw products state slice
 * @param rawProducts
 */
export const actionSetRawProducts = (rawProducts: ProductMenuItem[]) => ({
  type: SET_RAW_DATA,
  payload: {
    key: 'products',
    data: rawProducts,
  },
});
